import React from "react";
import PropTypes from "prop-types";
import grid from "./grid.scss";

export default class Column extends React.PureComponent {
  spanClasses() {
    const { colCount, colCountLg, colCountMd, colCountSm, colCountXs } =
      this.props;
    const col = `${grid.column} ${
      this.props.className ? this.props.className : ""
    }`;
    const spanClass =
      colCount >= 0 ? grid[`span_${colCount}`] : grid[`span_${colCountLg}`];
    const colCountXsClass = `span_xs_${colCountXs}`;
    const colCountSmClass = `span_sm_${colCountSm}`;
    const colCountMdClass = `span_md_${colCountMd}`;
    const colCountLgClass = `span_lg_${colCountLg}`;
    let sizeClasses = colCountXs >= 0 ? `${grid[colCountXsClass]} ` : "";
    sizeClasses += colCountSm >= 0 ? `${grid[colCountSmClass]} ` : "";
    sizeClasses += colCountMd >= 0 ? `${grid[colCountMdClass]} ` : "";
    sizeClasses += colCountLg >= 0 ? `${grid[colCountLgClass]}` : "";
    if (sizeClasses.length > 0) {
      return `${col} ${sizeClasses}`.trim();
    } else {
      return `${col} ${spanClass}`.trim();
    }
  }

  render() {
    return <div className={this.spanClasses()}>{this.props.children}</div>;
  }
}

/** Props **/
Column.defaultProps = {
  children: null,
  colCount: -1,
  colCountXs: -1,
  colCountSm: -1,
  colCountMd: -1,
  colCountLg: -1,
};

Column.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  colCount: PropTypes.number,
  colCountXs: PropTypes.number,
  colCountSm: PropTypes.number,
  colCountMd: PropTypes.number,
  colCountLg: PropTypes.number,
};
